import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import * as nprogress from "nprogress";

class Spinner extends Component {

  public state = {
    lastState: false
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (this.state.lastState !== nextProps.loading.showLoadingSpinner) {
      this.setState({
        lastState: nextProps.loading.showLoadingSpinner
      })
    }
  }

  public render() {
    if (this.props.loading.showLoadingSpinner === false) {
      nprogress.done();
      return null;
    }

    nprogress.configure({ showSpinner: false });
    nprogress.start();
    nprogress.inc();

    return (
      // <img
      //   className="loading-spinner"
      //   src={this.image.get("loading")}
      // />
      <div></div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.loading,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Spinner
);
